import { FC } from 'react';
import { AllieText } from '../../../../../components';
import { DataContentBaseProps } from './DataContent.types';
import { AllieDateField, DateFieldProps } from '../../../DateField';

interface ContentDateProps extends Omit<DateFieldProps, 'timestamp'> {
  timestamp?: number;
}

export const ContentDate: FC<DataContentBaseProps<ContentDateProps>> = ({
  data: { timestamp, format = 'DD-MM-YYYY' },
}) => (
  <AllieText>
    {timestamp ? <AllieDateField timestamp={timestamp} format={format} /> : '-'}
  </AllieText>
);
